import { configurationDataSchema, configurationSchema, selectedConfigurationSchema } from "@/lib/schema/configuration/configuration";
import { crmSystemSchema } from "@/lib/schema/crm/crm_system";
import z from "zod";

export const addCrmModalSimplifiedSchema = z.object({
    name: z.string().min(1, 'CRM Name is required'),
    crm_system: crmSystemSchema,
    selected_configuration: selectedConfigurationSchema.optional(),
    configuration: configurationSchema.optional(),
    configuration_data: configurationDataSchema.optional(),
    project_ids: z.array(z.string()).optional(),
    crm_project: z.array(z.object({
        name: z.string(),
        // crm_id: z.number(),
        selected_configuration: selectedConfigurationSchema.optional().nullable(),
        crm_config: z.array(z.object({
            name: z.string(),
            selected_configuration: selectedConfigurationSchema.nullable(),
        })).optional(),
    })).optional()
})